<template>
	<div>
		<div v-show="showcontent" class="margin-bottom-20">{{contenttext}}</div>
		<Upload
			ref="Upload"
			:headers="headers"
			with-credentials
			:show-upload-list="false"
			:beforeUpload="beforeUpload"
			:onSuccess="success"
			:onError="error"
			v-bind="$attrs"
			:multiple="false"
		>
			<Button class="margin-right-20"><Icon type="ios-cloud-upload-outline" :size="16"></Icon>&nbsp;请选择文件
			</Button>
			<Button v-show="showdownload" @click.stop="download"><Icon type="ios-cloud-download" :size="16"></Icon>&nbsp;下载模板
			</Button>
			<p v-if="file" class="margin-top-5">文件名称：{{file.name}}</p>
		</Upload>
		<footer class="padding-top-20 text-right">
			<Button class="margin-right-20" :loading="loading" type="primary" @click="handerSubmit">确认</Button>
			<Button @click="cancel">取消</Button>
		</footer>
	</div>
</template>
<script>
import { HttpUpload } from '@mods/service/base'
export default {
	props: ['download', 'refresh', 'showcontent', 'contenttext', 'showdownload'],
	data() {
		return {
			show: false,
			file: null,
			loading: false,
			headers: {
				Authorization: 'Bearer ' + global.AUTH_TOKEN,
			},
		};
	},
	methods: {
		async upload() {
			const { action, name } = this.$attrs;
			const formData = new FormData();
			formData.append(name, this.file);
			formData.append('contextId', global.SYSID);
			HttpUpload(action, formData).then(res => {
				this.success(res);
			}, err => {
				this.error(err)
			})
		},
		beforeUpload(file) {
			this.file = file;
			return false;
		},
		handerSubmit() {
			this.loading = true;
			this.upload();
			// this.$refs.Upload.post(this.file);
		},
		success(response) {
			if (response.code != 200 && response.status != 200) {
				this.$Message.error(response.message || '上传失败');
				this.loading = false;
			} else {
				this.$Message.success(response.message || '上传成功');
				if (this.refresh) {
					this.refresh();
				}
				this.cancel();
			}
		},
		error(error) {
            this.$VMessage.error({
                content: error.message || '上传失败',
                duration: 30,
                closable: true
            });
			this.loading = false;
		},
		cancel() {
			this.file = null;
			this.show = false;
			this.loading = false;
			this.$emit('on-close');
		},
	},
};
</script>


